<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                @invoke-method="invokeMethod($event)"
                                action="showUserDefinedField"
                            ></bc-btn-add>
                            <!-- <bc-reorder
                                ref="reorder"
                                :items="user_defined_fields"
                                primary-id="user_defined_id"
                            >
                                <template slot-scope="{ item }">
                                    {{ `${item.question}` }}
                                </template>
                            </bc-reorder> -->
                            <bc-btn-refresh
                                @invoke-method="dbGetUserDefinedFields()"
                            ></bc-btn-refresh>
                            <bc-search-menu
                                :params="axiosParams"

                            >
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input
                                            v-model="filter.search"
                                            :params="axiosParams"
                                        ></bc-search-input>
                                    </v-list-tile>

                                    <v-divider></v-divider>

                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table
                        :headers="headers"
                        :items="user_defined_fields"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                    >
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showUserDefinedField(props.item)">
								<td>{{ props.item.object_id }}</td>
								<td>{{ props.item.object_ref }}</td>
								<td>{{ props.item.question }}</td>
								<td>{{ props.item.field_type }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination
                        :page="page"
                        :params="axiosParams"
                        name="user_defined_field"
                    ></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="user_defined_field_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ currObjField('user_defined_id') ? $t('lang.edit_user_defined_field') : $t('lang.add_user_defined_field') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeUserDefinedFieldDialog"
                            :dialog-status="user_defined_field_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="user_defined_field">
                            <v-container grid-list-form>
                                <v-layout row wrap>
									<v-flex xs12>
										<bc-autocomplete
											:focus="user_defined_field_dialog"
											v-model="user_defined_field.object_id"
											:label="$t('lang.object_id')"
											:items="production_procedures"
											item-value="procedure_id"
											item-text="procedure_name"
											:rules="ifValid('user_defined_field.object_id')"
										></bc-autocomplete>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="user_defined_field.object_ref"
											:label="$t('lang.object_ref')"
											:counter="showCounter(user_defined_field.object_ref, 'user_defined_field.object_ref')"
											:rules="ifValid('user_defined_field.object_ref')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="user_defined_field.question"
											:label="`${$t('lang.question')} *`"
											:counter="showCounter(user_defined_field.question, 'user_defined_field.question')"
											:rules="ifValid('user_defined_field.question')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="user_defined_field.field_type"
											:label="`${$t('lang.field_type')} *`"
											:counter="showCounter(user_defined_field.field_type, 'user_defined_field.field_type')"
											:rules="ifValid('user_defined_field.field_type')"
										></v-text-field>
									</v-flex>

                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('user_defined_id')" color="error" @mouseup.left="$refs.delete_user_defined_field.openDialog()">{{ $t('lang.delete') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeUserDefinedFieldDialog()">{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyUserDefinedField(currObjField('user_defined_id') ? 'patch' : 'post', currObjField('user_defined_id'))">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_user_defined_field"
                :heading="$t('lang.delete_user_defined_field')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyUserDefinedField('delete', currObjField('user_defined_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.object_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.object_ref"), sortable: false, width: "25%" },
                { text: this.$t("lang.question"), sortable: false, width: "25%" },
                { text: this.$t("lang.field_type"), sortable: false, width: "25%" },
            ],

            user_defined_field: {
                object_id: "",
                object_ref: "parts_process",
                question: "",
                field_type: "text",
            },
            current_obj: null,
            filter: {
                search: "",
                object_ref: "",
                page_size: 0,
                page_num: 0,
            },
            user_defined_field_dialog: false,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "showUserDefinedField" },
                { title: this.$t("lang.refresh"), action: "dbGetUserDefinedFields" },
                // { title: this.$t('lang.reorder'), action: "openDialog", ref: "reorder" },
            ],
            dbGetUserDefinedFields: _.debounce(this.getUserDefinedFields, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchUserDefinedField", {
                url: "user_defined_fields",
                method: "get",
                stateProperty: "user_defined_fields",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.user_defined_fields) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchUserDefinedField", {
                url: "user_defined_fields",
                method: "get",
                stateProperty: "user_defined_fields",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.user_defined_fields) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_user_defined_field: (state) => state.validation.rules_user_defined_field,
            default_filter: (state) => state.user_defined_fields.user_defined_fields_filter,
            page: (state) => state.user_defined_fields.page,
            user_defined_fields: (state) => state.user_defined_fields.user_defined_fields,
            production_procedures: (state) => state.production.production_procedures,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        getArrayData() {
            if (this.production_procedures == null) this.getProductionProcedures();
        },
        getProductionProcedures() {
            this.$store
                .dispatch("fetchProduction", {
                    url: "production_procedures",
                    method: "get",
                    stateProperty: "production_procedures",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                });
        },
        closeUserDefinedFieldDialog() {
            this.user_defined_field_dialog = false;
            this.$refs.delete_user_defined_field.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getUserDefinedFields() {
            this.startLoader();
            this.$store
                .dispatch("fetchUserDefinedField", {
                    url: "user_defined_fields",
                    method: "get",
                    stateProperty: "user_defined_fields",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.user_defined_field_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },

        modifyUserDefinedField(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("user_defined_field")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchUserDefinedField", {
                                pk: "user_defined_id",
                                id: id,
                                url: `user_defined_fields/${id ? id : ""}`,
                                method: method,
                                stateProperty: "user_defined_fields",
                                mutate: true,
                                body: this.user_defined_field,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeUserDefinedFieldDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showUserDefinedField(item = null) {
            this.current_obj = item;
            this.getArrayData();
            if (this.$refs.user_defined_field) item ? this.$refs.user_defined_field.resetValidation() : this.$refs.user_defined_field.reset();

            this.$nextTick(() => {
                this.assignObj(this.user_defined_field, item, this.rules_user_defined_field);
                this.user_defined_field_dialog = true;
                // this.user_defined_field.object_ref = 'parts_process';
            });
        },
    },
};
</script>
